import React from "react";
import { C, btnS, btnD } from "../../../../lib/styles.js";
import { SESSION_TYPE_LABELS } from "../../../../lib/constants.js";
import { fmtDate } from "../../../../lib/utils.js";

export default function DeleteSessionConfirm({ session, onCancel, onConfirm }) {
  if (!session) return null;
  const capLen = (session.captureLog || []).length;
  const hiRes = (session.captureLog || []).filter(r => r?.hiResRequested).length;

  const items = [];
  if (capLen) items.push(`${capLen} capture item${capLen === 1 ? "" : "s"}`);
  if (session.captureNotes) items.push("Capture notes");
  if (hiRes) items.push(`${hiRes} hi-res request${hiRes === 1 ? "" : "s"}`);
  if (session.issues) items.push("Issue log");
  if (session.actualArrival || session.actualWrap) items.push("Actual arrival / wrap");
  if (session.travelTime) items.push("Travel time");
  if ((session.peoplePresent || []).length) items.push(`${session.peoplePresent.length} people present`);

  const dateLabel = session.date ? ` on ${fmtDate(session.date)}` : "";

  return (
    <div style={{
      marginTop: 14, background: C.surface, border: `1px solid ${C.border}`,
      borderRadius: 6, padding: "16px 18px", maxWidth: 440,
    }}>
      <div style={{ fontSize: 13, color: C.text, marginBottom: 6, fontWeight: 500 }}>
        Remove {SESSION_TYPE_LABELS[session.sessionType] || session.sessionType} session{dateLabel}?
      </div>
      <div style={{ fontSize: 12, color: C.muted, marginBottom: 12 }}>
        This session has data that will be lost:
        <ul style={{ margin: "6px 0 0", paddingLeft: 18, fontSize: 11, color: C.muted }}>
          {items.map((it, i) => <li key={i}>{it}</li>)}
        </ul>
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button style={{ ...btnS, padding: "5px 12px", fontSize: 11 }} onClick={onCancel}>Cancel</button>
        <button style={{ ...btnD, padding: "5px 12px", fontSize: 11 }} onClick={onConfirm}>Delete session</button>
      </div>
    </div>
  );
}
